import React from 'react';
import * as PropTypes from 'prop-types';
import Modal from 'antd-mobile/lib/modal';
import Icon from '../../Icon';
import { noop } from '../utils';
import 'antd-mobile/lib/modal/style/css';

BottomPopup.propTypes = {
  children: PropTypes.node,
  visible: PropTypes.bool,
  deniedBtnText: PropTypes.string,
  confirmBtnText: PropTypes.string,
  onDeniedBtnClick: PropTypes.func,
  onConfirmBtnClick: PropTypes.func,
  onCloseBtnClick: PropTypes.func,
  noHeader: PropTypes.bool,
  title: PropTypes.string,
  showCloseBtn: PropTypes.bool,
  wrapClassName: PropTypes.string,
  popClassName: PropTypes.string,
  mask: PropTypes.bool,
  maskStyle: PropTypes.shape({}),
  onClose: PropTypes.func,
  afterClose: PropTypes.func,
  maskClosable: PropTypes.bool
};

export default function BottomPopup(props) {
  const {
    children,
    visible,
    deniedBtnText,
    confirmBtnText,
    onDeniedBtnClick,
    onConfirmBtnClick,
    onCloseBtnClick = noop,
    noHeader,
    title,
    showCloseBtn,
    wrapClassName,
    popClassName,
    mask,
    maskStyle,
    onClose,
    afterClose,
    maskClosable = true
  } = props;

  return (
    <Modal
      className={`bottom-popup-pop ${popClassName}`}
      wrapClassName={wrapClassName}
      popup
      visible={visible}
      animationType="slide-up"
      mask={mask}
      maskStyle={maskStyle}
      onClose={onClose}
      afterClose={afterClose}
      maskClosable={maskClosable}
    >
      {!noHeader && (
        <div className="header-box">
          {onDeniedBtnClick && (
          <div
            onClick={() => {
              onClose();
              onDeniedBtnClick();
            }}
          >
            {deniedBtnText || '取消'}
          </div>
          )}
          <p>{title}</p>
          {onConfirmBtnClick && (
          <div
            onClick={() => {
              const result = onConfirmBtnClick();
              // 根据返回确定弹窗能不能关闭
              // 返回不是 boolean 类型的情况都允许关闭
              if (typeof result !== 'boolean') {
                onClose();
                return;
              }

              if (result) {
                onClose();
              }
            }}
          >
            {confirmBtnText || '确定'}
          </div>
          )}
          {
            showCloseBtn && (
              <Icon
                className="icon-close"
                name="close"
                onClick={
                  () => {
                    onClose();
                    onCloseBtnClick();
                  }
                }
              />
            )
          }
        </div>
      )}
      {children}
    </Modal>
  );
}
